import StatsProgressBar from '~/statistics-v2/components/StatsProgressBar'

interface ProgressCardProps {
  title: string
  value: string | number | null
  isProgress?: boolean
  subTitle?: string
}

export default function ProgressCard({ title, value, isProgress, subTitle }: ProgressCardProps): React.ReactElement {
  return (
    <div className="flex flex-col justify-between p-4 h-30 w-37.5 lg:w-50 border rounded-3 border-blue-pastel bg-purple-gdark">
      <div className="flex flex-col w-1/2 gap-1 mb-3">
        <p className="text-gray-lavender text-xs leading-4">{title.toUpperCase()}</p>
        <p className="text-lg font-bold text-white leading-8">
          {value !== null ? `${value}${isProgress ? '%' : ''}` : '-'}
        </p>
        {subTitle && !isProgress && <p className="text-green-lime text-xxxs">{subTitle}</p>}
      </div>
      {isProgress && (
        <StatsProgressBar
          barHeight="slim"
          barType="straight"
          progressPercentage={value ? parseFloat(value.toString()) : 0}
        />
      )}
    </div>
  )
}
